module.exports = __webpack_public_path__ + "static/N2N8-42bafba83e70b7b498e2ea527d08b177.jpg";